import React from 'react';
import classNames from 'classnames';

import css from './IconHeart.module.css';

/**
 * Heart icon used for favorites.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @param {string?} props.ariaLabel
 * @param {boolean?} props.isFilled
 * @returns {JSX.Element}
 */
const IconHeart = props => {
  const { className, rootClassName, ariaLabel, isFilled = false } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      role="img"
      aria-label={ariaLabel}
    >
      {isFilled ? (
        <path
          className={css.filled}
          d="M12 21s-7.1-4.4-9.4-8.2C1.4 10.7 2 7.8 4.3 6.3c1.9-1.3 4.4-.9 6 1 .4.5.8 1 1.7 1.9.9-.9 1.3-1.4 1.7-1.9 1.6-1.9 4.1-2.3 6-1 2.3 1.5 2.9 4.4 1.7 6.5C19.1 16.6 12 21 12 21z"
        />
      ) : (
        <path transform="translate(3.29, 4.4)" d="M16.0761 1.34319C15.6504 0.917358 15.1451 0.57956 14.5889 0.349091C14.0327 0.118623 13.4365 0 12.8344 0C12.2323 0 11.6362 0.118623 11.0799 0.349091C10.5237 0.57956 10.0184 0.917358 9.59274 1.34319L8.70941 2.22652L7.82608 1.34319C6.96633 0.483445 5.80027 0.000445635 4.58441 0.000445644C3.36855 0.000445653 2.20249 0.483445 1.34274 1.34319C0.482999 2.20293 9.05887e-09 3.36899 0 4.58485C-9.05887e-09 5.80072 0.482999 6.96678 1.34274 7.82652L2.22608 8.70986L8.70941 15.1932L15.1927 8.70986L16.0761 7.82652C16.5019 7.40089 16.8397 6.89553 17.0702 6.33932C17.3006 5.7831 17.4193 5.18693 17.4193 4.58485C17.4193 3.98278 17.3006 3.38661 17.0702 2.83039C16.8397 2.27418 16.5019 1.76882 16.0761 1.34319Z" fill="white" />
      )}
    </svg>
  );
};

export default IconHeart;

